import React, { useState, useEffect, useContext, useRef } from 'react';
import { Navbar, Dropdown, Modal, Image } from 'react-bootstrap';
import { useNavigate,useLocation } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { userlogo } from '../../helpers/formatter';
import godrejLogo from "../../assets/images/godrej-logo-dark.svg";
import dotIcon from '../../assets/icons/ThreeDotIcon.svg';
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import axios from 'axios';
import '../../App.css';
import { AuthContext } from '../../contexts/AuthContext';


const Header = (props) => {
  const context = useContext(AuthContext);
  const dropdownRef = useRef(null);
  const headerRef = useRef(null); 

  const MySwal = withReactContent(Swal);
  const navigate = useNavigate();
  const { instance } = useMsal();
  const [show, setShow] = useState(false);
  const [userName, setUserName] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  console.log("headerprops", props);
  const location = useLocation();
  console.log("locationpathname", location.pathname);
  console.log("location", location);
  let MenuName;
  if (location.pathname == "/dashboard") {
    MenuName = "Dashboard"
  }
  if (location.pathname == "/roleandauthorization") {
    MenuName = "Role and Authorization"
  }

  useEffect(() => {
    // Retrieve user details from session storage
    // const storedUserName = sessionStorage.getItem('userName') ;
    //const storedUserEmail = sessionStorage.getItem('userEmail');
    const storedUserName = context.emp_name;
    console.log("storedUserName",storedUserName);
    // setUserName(storedUserName);
    setUserName(storedUserName);
  }, []);

  const CustomToggle = React.forwardRef(({ onClick }, ref) => (
    <img
      src={dotIcon}
      alt="arrow"
      className="user-action"
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
        setDropdownOpen(!dropdownOpen);
      }}
    />
  ));

  async function handleLogout() {
    try {
      const token = sessionStorage.getItem("Token");
      if (token) {
        await axios.post(
          `${process.env.REACT_APP_MASTER_URL}/enquiry/logout`,
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }
    } catch (e) {
      console.error('Logout error:', e);
    } finally {
      sessionStorage.removeItem("UserData");
      navigate('/');
      instance.logoutRedirect().catch((e) => console.error(e));
    }
  }


  useEffect(() => {
    const timer = setTimeout(() => { }, 10000);
    return () => clearTimeout(timer);
  }, []);

  const handleSubmit = async () => {

    let confirmationMessage = "Are you sure you want to Logout ?";
    let title = "Logout";

    MySwal.fire({
      title: title,
      html: confirmationMessage
    }).then(async (selection) => {
      if (selection.isConfirmed) {
        handleLogout();
      }
    });

  }
  console.log("Header");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  return (
    <>
      <Navbar bsPrefix="header" className="header his-header">
        <Image className="head-logo me-5 my-1" src={godrejLogo} />
        <div className="menu-name-header">Dealer Portal</div>
        <div className="user-section">
          <div className='user-details'>
          
          <div className="user-info">
            <span className="user-name">{context.emp_name}</span>
            {/* <span className="user-email">{context.role_code}</span> */}
          </div>

          <div className="user-logo">
            {userlogo(userName)}
          </div>

          <div className="logout-arrow" onClick={() => {
            handleSubmit()
          }} />
          </div>

          <Dropdown autoClose="outside" show={dropdownOpen} ref={dropdownRef}>
            <Dropdown.Toggle as={CustomToggle}/>
            <Dropdown.Menu bsPrefix="headerMenu">
              {dropdownOpen && (
                <Dropdown.Item bsPrefix="headerMenu-item" eventKey="1" onClick={() =>  setShow(true)}>
                  <div className='logout-details'>
                  <div className = "logout-class" onClick={() => { handleSubmit()}}> 
                    <div className="logout-arrow"/>Logout</div> 
                    </div>
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
            
          </Dropdown>

        </div>
      </Navbar>
      <Modal size="lg" className={show ? 'opacity-0 userMasterModal' : 'opacity-100 userMasterModal'} />
      {/* <div className="mobile-header">{props.selectedMenu}</div> */}
    </>
  );
};

export default Header;

